import React from 'react'
import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'

import { Typography, Button, Column, Container, Spinner } from 'components'
import Logo from '../../components/Logo'
import Row from '../../components/Row'
import Toast from '../../components/Toast'
import { PhoneInput } from 'components/PhoneInput'

import { recoverEmail } from '../../redux/actions'
import * as routes from './../../settings/_routesSettings'
import { history } from '../../routers/AppRouter'
import { getAuthToken } from 'utils/authHelper'

class EmailRecover extends Component {
  state = {
    cellphone: '',
    cleanCellphone: '',
    cellphoneHasError: true,
    step: 1,
  }

  componentWillMount() {
    const hasToken = getAuthToken()
    if (hasToken) {
      history.push(routes.HOME_PSIC)
    }
  }

  handleResendPhone = () => {
    this.setState({
      cellphone: '',
      cleanCellphone: '',
      step: 1,
    })
  }

  onSubmit = e => {
    e.preventDefault()

    this.props.onRecoverEmail(this.state.cleanCellphone)
      .then(() => {
        if (this.props.success) {
          this.setState({ step: 2 })
        }
      })
  }

  handleCellphoneChange = (value) => {
    let cleanValue = value ? value.replace('+', '') : value

    if (value === '' ||
      value === undefined) {
      this.setState({ cellphoneHasError: true })
    } else {
      this.setState({
        cellphone: value,
        cleanCellphone: cleanValue,
        cellphoneHasError: false,
      })
    }
  }

  handleStepChange = (step) => {
    switch (step) {
    case 2:
      return (
        <Container isView>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="title" Tag="h1" gutterBotton>
                <Trans>
                    SMS enviado!
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="paragraph" Tag="p" gutterBotton>
                <Trans>
                    Enviamos um SMS para o número cadastrado. Ao prosseguir você será redirecionado para acessar sua conta.
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="paragraph" Tag="p" bold>
                <Trans>
                    Não recebeu o SMS?
                </Trans>
                <Typography id="resend"
                  bold
                  color="primary"
                  onTextClick={this.handleResendPhone}
                  Tag="span"
                  type="paragraph"
                  style={{ 'paddingLeft': '8px' }}
                  underline>
                  <Trans>
                      Reenviar
                  </Trans>
                </Typography>
              </Typography>
            </Column>
          </Row>
          <Row justify="center" margin="25px 0 0">
            <Column colWidth={4}>
              <Link to={routes.LOGIN}>
                <Button id="to-login" text="OK" type="submit" />
              </Link>
            </Column>
          </Row>
        </Container>
      )

    default:
      return (
        this.props.loading ? (<Spinner />) :
          (
            <Container isView>
              <Row justify='center'>
                <form className="hasMarginBottom" onSubmit={this.onSubmit}>
                  <Row justify="center">
                    <Column colWidth={4}>
                      <Typography type="title" Tag="h1" gutterBotton>
                        <Trans>
                            Recuperar e-mail
                        </Trans>
                      </Typography>
                    </Column>
                  </Row>
                  {
                    this.props.errors &&
                      this.props.errors.sysError.map(error => (
                        <Row key={error.code}
                          margin="1.5rem 0"
                          justify='center'>
                          <Column colWidth={5}>
                            <Toast variant="error"
                              message={'Verifique o telefone digitado'}
                            />
                          </Column>
                        </Row>
                      ))
                  }
                  <Row justify="center">
                    <Column colWidth={4}>
                      <Typography type="paragraph" Tag="p" gutterBotton>
                        <Trans>
                            Informe seu número de celular abaixo para enviarmos por SMS seu e-mail cadastrado:
                        </Trans>
                      </Typography>
                    </Column>
                  </Row>
                  <Row justify="center">
                    <Column colWidth={4}>
                      <PhoneInput
                        onChangePhone={value => this.handleCellphoneChange(value)}
                        cellPhone={this.state.cellphone}
                      />
                    </Column>
                  </Row>
                  <Row justify="center" margin="25px 0 0">
                    <Column colWidth={4}>
                      <Button id="next"
                        disabled={this.state.cellphoneHasError}
                        text="Enviar"
                        type="submit"
                      />
                    </Column>
                  </Row>
                </form>
              </Row>
            </Container>
          )
      )
    }
  }

  render() {
    return (
      <Container isView>
        <Row justify='center' margin='6.2rem 0 3.0rem'>
          <Column align='center' justify='center' colWidth={4}>
            <Column colWidth={3}>
              <div>
                <Logo fill="#1f35b5" 
                  onClickLogo={() => window.location.href = process.env.REACT_APP_INSTITUTIONAL_URL}
                />
              </div>
            </Column>
          </Column>
        </Row>
        {this.handleStepChange(this.state.step)}
      </Container>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.emailRecovery.loading,
    success: state.emailRecovery.success,
    errors: state.emailRecovery.errors,
  }
}

const mapDispatchToProps = dispatch => {
  return { onRecoverEmail: (recoveryData) => dispatch(recoverEmail(recoveryData)) }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailRecover)